exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vdr{box-sizing:border-box}.vdr,span.rotate{position:absolute}span.rotate{font-size:20px;top:-30px;cursor:pointer;right:-30px;color:#000}.vdr-stick{box-sizing:border-box;position:absolute;font-size:1px;background:#fff;border:1px solid #6c6c6c;box-shadow:0 0 2px #bbb}.inactive .vdr-stick{display:none}.vdr-stick-br,.vdr-stick-tl{cursor:nwse-resize}.vdr-stick-bm,.vdr-stick-tm{left:50%;cursor:ns-resize}.vdr-stick-bl,.vdr-stick-tr{cursor:nesw-resize}.vdr-stick-ml,.vdr-stick-mr{top:50%;cursor:ew-resize}.vdr-stick.not-resizable{display:none}.vdr.active:before{cursor:move}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d6ecc2c4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/lib/vueDragResizeRotate.vue
// module id = 7
// module chunks = 0